module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("93wT2"))).then(() => parcelRequire('3a9aZ'));